export default "__VITE_ASSET__CxScUbFB__"